var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"page-header\">\n<h1 translate=\"PUBLIC_BOOKING.LOGIN.HEADING\"></h1>\n</div>\n<div class=\"sign-in-container\">\n<div bb-member-login bb-custom-login-form>\n</div>\n<div bb-login></div>\n<div class=\"col-sm-offset-4 col-sm-5\">\n<div class=\"form-group\">\n<span translate=\"PUBLIC_BOOKING.LOGIN.NO_ACCOUNT\"></span>\n<a ng-click=\"decideNextPage('member/_templates/steps/register.html')\" translate=\"PUBLIC_BOOKING.LOGIN.REGISTER_BTN\">\n</a>\n</div>\n</div>\n</div>\n";
var id1="member/_templates/steps/login.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
exports.id=id1;
exports.template=v1;


//////////////////
// WEBPACK FOOTER
// ../node_modules/bookingbug-angular/src/member/_templates/steps/login.html
// module id = 1169
// module chunks = 0